







































































































import { Component, mixins } from 'nuxt-property-decorator';

import { usePerformanceCategories } from '@/composables/performance-categories';
import { useActivePerformances } from '@/composables/performances';
import { PageContentMixin } from '@/composables/page-content';

import type { ScenkonstOtPerformanceListingContent } from '@/graphql/generated';
import { IconAngleDown, IconAngleUp, IconArrowRight } from '@/icons';
import { ComposableMixin } from '@/mixins/composable';

interface Category {
  id: string;
  name: string;
  parent: string;
}

@Component({
  components: {
    IconAngleDown,
    IconAngleUp,
    IconArrowRight,
  },
})
export default class ShowsPage extends mixins(
  PageContentMixin<ScenkonstOtPerformanceListingContent>(),
  ComposableMixin(usePerformanceCategories),
  ComposableMixin(useActivePerformances),
) {
  isolatedPerformanceCategory: string | null = null;
  enabledPerformanceCategories: string[] = [];

  filterOpen = false;

  get page () {
    return {
      title: this.pageContent.title,
      slug: '',
      backgroundColor: this.pageContent.blockColorAttribute?.color,
    };
  }

  get categories () {
    const categories = this.performanceCategories.reduce((categories, root) => {
      if (!this.isolatedPerformanceCategory || this.isolatedPerformanceCategory === root.id)
        categories.push(
          ...root.children.map(category => ({
            id: category.id,
            name: category.name,
            parent: root.name,
          })),
        );

      return categories;
    }, [] as Category[]);

    const sortedCategories = categories
      .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

    return this.resolveDuplicateCategories(sortedCategories);
  }

  get activeCategories () {
    const stages = [];
    this.performanceCategories
      .filter(root => !this.isolatedPerformanceCategory || root.id === this.isolatedPerformanceCategory)
      .forEach((root) => {
        root.children
          .filter(root => !this.enabledPerformanceCategories.length || this.enabledPerformanceCategories.includes(root.id))
          .forEach((category) => {
            if (category.performances.length === 0)
              return;

            const existingStage = stages.find(stage => stage.name === category.name);
            if (existingStage)
              existingStage.performanceIds.push(
                ...category.performances.map(performance => performance.id),
              );
            else
              stages.push({
                name: category.name,
                performanceIds: category.performances.map(performance => performance.id),
              });
          });
      });

    return stages;
  }

  get shows () {
    return (ids: string[]) => this.performances
      .filter(performance => ids.includes(performance.id));
  }

  resolveDuplicateCategories <T extends Category> (categories: T[]) {
    const hash = new Map<string, boolean>();

    categories.forEach((category) => {
      if (hash.has(category.name))
        hash.set(category.name, true);
      else
        hash.set(category.name, false);
    });

    return categories.map(category => ({
      ...category,
      suffix: hash.get(category.name) ? category.parent : null,
    }));
  }

  toggleFilter () {
    this.filterOpen = !this.filterOpen;
  }

  toggleDisabledPerformanceCategory (id: string) {
    if (this.enabledPerformanceCategories.includes(id))
      this.enabledPerformanceCategories = this.enabledPerformanceCategories.filter(category => category !== id);
    else
      this.enabledPerformanceCategories.push(id);
  }
}
